var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAL0lEQVR42mNgGN7gPxD9B1NkaiTLAHTN9HcBVcIA05wBMuA/GiZbI8kGUWzAEAMA9m03yW7foZAAAAAASUVORK5CYII=";
  export default img;